import {loadStripe} from '@stripe/stripe-js';
import {STRIPE_PUBLIC_KEY} from '$constants/env';

// Memoize the stripe promise to prevent recreation on every render
let stripePromiseInstance: ReturnType<typeof loadStripe> | null = null;

export const stripePromise = () => {
  if (!stripePromiseInstance) {
    stripePromiseInstance = loadStripe(STRIPE_PUBLIC_KEY);
  }
  return stripePromiseInstance;
};
